import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_EDIT_ARTIST_SET_MUTATION = gql`
  mutation Post(
    $id: String
    $artistName: String
    $artistSetName: String
    $artistSetReadableName: ObjectLocalizationInput
    $artistSlugName: String
    $artistSetSlugName: String!
    $artistReadableName: ObjectLocalizationInput
    $countryCode: String
    $dateTimeEndReal: String
    $dateTimeStartReal: String
    $dateTimeStartHuman: String
    $artistSetGenres: [String]
    $duration: Int
    $image: ObjectLocalizationInput
    $mediaLinks: MediaLinksInput
    $postUri: String
    $shortTitle: ObjectLocalizationInput
    $show: Boolean
    $smallText: ObjectLocalizationInput
    $venueSlugName: String
    $stock: Int
    $timezone: String
  ) {
    postEditArtistSet(
      id: $id
      artistName: $artistName
      artistSetName: $artistSetName
      artistSetGenres: $artistSetGenres
      artistSetReadableName: $artistSetReadableName
      artistSlugName: $artistSlugName
      artistSetSlugName: $artistSetSlugName
      artistReadableName: $artistReadableName
      countryCode: $countryCode
      dateTimeEndReal: $dateTimeEndReal
      dateTimeStartReal: $dateTimeStartReal
      dateTimeStartHuman: $dateTimeStartHuman
      duration: $duration
      image: $image
      mediaLinks: $mediaLinks
      postUri: $postUri
      shortTitle: $shortTitle
      show: $show
      smallText: $smallText
      venueSlugName: $venueSlugName
      stock: $stock
      timezone: $timezone
    ) {
      isAuth
      isEdited
      artistSetSlugName
    }
  }
`;

const postEditArtistSet = async ({
  id, artistName, artistSetName, artistSetReadableName, artistSetGenres, artistSlugName, artistSetSlugName,
  artistReadableName, countryCode, dateTimeEndReal, dateTimeStartReal, dateTimeStartHuman, duration, image,
  mediaLinks, postUri, shortTitle, show, smallText, venueSlugName, stock, timezone,
}) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_EDIT_ARTIST_SET_MUTATION,
        variables: {
          id,
          artistName,
          artistSetName,
          artistSetReadableName,
          artistSlugName,
          artistSetGenres,
          artistSetSlugName,
          artistReadableName,
          countryCode,
          dateTimeEndReal,
          dateTimeStartReal,
          dateTimeStartHuman,
          duration,
          image,
          mediaLinks,
          postUri,
          shortTitle,
          show,
          smallText,
          venueSlugName,
          stock,
          timezone,
        },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { postEditArtistSet: postEditArtistSetValidationData },
    } = result;

    if (postEditArtistSetValidationData) {
      return postEditArtistSetValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postEditArtistSetValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postEditArtistSet Error: ${error}`);
    return null;
  }
};

export default postEditArtistSet;
